import React, { useState } from 'react';
import {
    Backdrop,
    Box,
    CircularProgress,
    Fade,
    Grid,
    Modal,
    Typography,
    Divider,
} from '@mui/material';
import { useSelector } from 'react-redux';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '450px' }, // Slightly narrower for a "Profile" feel
    maxHeight: '90vh',
    overflowY: 'auto',
    bgcolor: 'background.paper',
    borderRadius: 3,
    boxShadow: 24,
    p: { xs: 3, md: 4 },
    outline: 'none',
};

const Profile = ({ open, setOpen }) => {
    const [loading] = useState(false);
    const handleClose = () => setOpen(false);

    // Safety check: accessing the first element of the user array
    const userData = useSelector((state) => state.user.data?.[0]);

    return (
        <Modal
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{ backdrop: { timeout: 500 } }}
        >
            <Fade in={open}>
                <Box sx={modalStyle}>
                    <Typography variant="h5" fontWeight={600} mb={1} color="primary">
                        Perfil de Usuario
                    </Typography>
                    <Typography variant="subtitle2" color="text.secondary" mb={3}>
                        {userData?.type_user || 'Usuario'}
                    </Typography>

                    <Divider sx={{ mb: 3 }} />

                    {loading ? (
                        <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                            <CircularProgress size={40} />
                        </Box>
                    ) : (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography variant="caption" color="text.secondary">Nombre Completo</Typography>
                                <Typography variant="body1" fontWeight={500}>{userData?.name}</Typography>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption" color="text.secondary">Teléfono</Typography>
                                <Typography variant="body1">{userData?.phone}</Typography>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption" color="text.secondary">Correo</Typography>
                                <Typography variant="body1">{userData?.email}</Typography>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption" color="text.secondary">Documento</Typography>
                                <Typography variant="body1">{userData?.document}</Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <Typography variant="caption" color="text.secondary">Oficina / Cargo</Typography>
                                <Typography variant="body1">{userData?.office_name}</Typography>
                            </Grid>
                        </Grid>
                    )}
                </Box>
            </Fade>
        </Modal>
    );
};

export default Profile;